export default __webpack_public_path__ + "static/media/M12.cb75bd52.jpg";